import React, { Component } from 'react'
import './FAQ.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class FAQ extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Frequently Asked Questions</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default">Frequently Asked Questions</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr ft1 faq">
                        <h3 className="pg ftr">
                            1. CAN YOU SHIP TO COUNTRIES OUTSIDE OF INDIA THROUGH A FREIGHT FORWARDING ADDRESS? 
                        </h3>
                            <div className="pg">
                                <span style={{"fontWeight": "400"}}>
                                    At this time, we are only able to ship to addresses within INDIA, and we cannot accept freight forwarding addresses.
                                </span>
                            </div>
                        
                        <h3 className="pg ftr">
                            2. WHAT CURRENCY ARE ITEMS DISPLAYED IN?
                        </h3>
                            <div className="pg">
                                <span style={{"fontWeight": "300"}}>
                                    All items on the StyleCabbie website are displayed in INDIAN currency only.
                                </span>
                            </div>
                        
                        {/* <h3 className="pg ftr">
                        3. CAN I USE MY STYLE CABBIE GIFT CARD TOWARD MY ONLINE ORDER?
                        </h3>    
                            <p className="pg"><span style={{"font-weight": "300;"}}>
                            You may redeem StyleCabbie’s eGift cards at StyleCabbie’s online store.
                                </span>
                            </p>
                        
                        <h3 className="pg ftr">
                        4. DOES MY STYLECABBIE’s GIFT CARD AND PROMOTIONAL GIFT CARD EXPIRE?
                        </h3>
                        <p className="pg"><span style={{"font-weight": "300;"}}>
                        Purchased StyleCabbie eGift cards do not expire. Promotional cards issued by StyleCabbie often have expiration dates. Please check the terms and conditions of the specific promotion.
                        </span>
                        </p>

                        <h3 className="pg ftr">
                        5. HOW CAN I CHECK THE BALANCE OF MY STYLECABBIE eGIFT CARD OR PROMOTIONAL GIFT CARD?
                        </h3>    
                        <p className="pg"><span style={{"font-weight": "300;"}}>
                        To check your balance, please click on this link
                        </span>
                        </p> */}

                        <h3 className="pg ftr">
                            3. HOW DO I PURCHASE AN ITEM I SAW ON YOUR SITE, WHICH IS NOT AVAILABLE FOR SALE ONLINE?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                You may contact us at <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> and an associate will be pleased to assist you with your inquiry.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            4. WHEN I ADD AN ITEM TO MY SHOPPING CART, IS THE ITEM RESERVED FOR ME UNTIL I DECIDE TO PLACE MY ORDER?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Items added to your shopping cart are not reserved until you place your order. To avoid being disappointed, we encourage you to place your order once you are certain of your intent to purchase it. Please note fulfillment of items within your order is not guaranteed until you receive a shipping confirmation email.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            5. CAN I MODIFY MY ONLINE ORDER?.
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                We begin to process orders immediately, so we may be unable to make any changes. For further assistance, please contact <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a>. 
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            6. WILL ALL ITEMS IN MY ORDER ARRIVE IN THE SAME SHIPMENT?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Orders placed on <a className="customer-care" href="/">StyleCabbie.com</a> may ship from our distribution centre. You may receive your items in multiple shipments. You will not be charged multiple shipping fees, if shipping fees are applicable to your one order.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            7. CAN I RETURN MY STYLECABBIE.COM PICK UP ORDER AFTER PICK UP?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Please read our <a className="refunds-returns" href="mailto:support@stylecabbie.com">Return Policy</a>. Your order number and pick up confirmation will be required to process the return
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            8. HOW DO I PLACE MY ORDER?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Once you have decided on the specific product that you’d like to purchase from us, please select the Size that you wish to buy.
                                TIP: Use the size chart on every product page placed below to the size to choose the right size.

                                <p className="p_1">
                                    Select Add to Bag to add the product to your cart. If there are other products that you’d like to buy from us, continue shopping.
                                    TIP: Click ‘Qty’ if you want to buy multiple products of the same type.
                                </p>

                                <p className="p_1">
                                    Select Place Order to buy the product. Submit your shipping address, select a mode of payment, and confirm your order by making the payment.
                                    TIP: Pay online to get a 10% StyleCabbie Coupon . Shop for more than Rs.1000 to get free shipping.
                                </p>

                                {/* <p className="p_1">Cashback on prepaid orders will get credited to your next purchase once the order gets shipped.</p> */}
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            9. MY ORDER IS NOT YET PACKED/SHIPPED?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Since our website is not a marketplace and all the products we sell are manufactured by us. We conduct quality checks before we send out a product to you so you get the best with every order you place. So, it may take anywhere between 4 to 5 working days before the shipment goes out from our warehouse. If this is not the case then please share your query in detail along with the order id number. Our <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive will work on your query. We will get back to you in the next 24 hours.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            10. HOW DO I KNOW IF MY ORDER WAS SUCCESSFULLY PLACED?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Once your order is placed, you can find details of your order:<br />
                                The order confirmation page<br />
                                E-mail confirmation sent to your registered E-mail id.<br />
                                The order confirmation page you will be directed to after placing your order Email<br /> confirmation sent to your registered e-mail id.<br />
                                SMS confirmation sent to your registered mobile number.<br />
                                We will send you another confirmation once we ship your order.  
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            11. What are the charges that will apply on my order?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                We ensure there are no hidden charges in our entire checkout process<br />
                                Free shipping on all prepaid orders<br />
                                COD charges of ₹ 75 per product if you choose cash-on-delivery as your mode of payment.<br />
                                The price of the products you see are inclusive of taxes.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            12. WHY CAN’T I SEE THE CASH-ON-DELIVERY (COD) OPTION?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                In a few pincodes, we are unable to provide the cash-on-delivery payment option currently. You may however, use for any other mode of payment such as Debit Card, Credit Card.<br />
                                You may have defaulted in receiving your items and/or making any payments when the carrier person came to deliver your order package at your destination.
                            </span>
                        </div>
                        
                        <h3 className="pg ftr">
                            13. I AM UNABLE TO ADD PRODUCTS TO MY CART?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Contact our customer service at <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a>, executive and we will resolve this. We’ll get back to you within 24 hours:
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            14. MY ORDER STATUS IS SHOWING ORDER SHIPPED BUT NOT YET DELIVERED?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                We apologise for the inconvenience. Please share your query in detail along with the order id number, our <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive will work on your query . We will get back to you in the next 24 hours.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            15. I HAVE NOT RECEIVED AN ORDER CONFIRMATION EMAIL OR NOTIFICATIONS?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Please check your order has been placed on the My Orders page<br />
                                Don’t worry, you will receive a confirmation e-mail and SMS soon within 12 hours.<br />
                                Please check your spam folder as well.<br />
                                After 12 hours, please contact the <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive and we will help in looking into the issue.
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            16. HOW DO I WANT TO CHANGE MY DELIVERY ADDRESS OR PHONE NUMBERS?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                If your order has been shipped we will not be able to make any changes in the delivery address. We can inform our courier partner to send the shipment back to us by contacting us at <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive. Please share the order id number and let us know the next course of action. Will try our best to help you out. Thank You.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            17. THE ORDER I HAVE RECEIVED IS NOT WHAT I EXPECTED. WHAT SHOULD I DO? 
                        </h3>
                        <h2 className="pg">We’re extremely sorry for the inconvenience caused. Please reach out to us below with the following info:</h2>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Image of the product
                                Take a picture

                                <p className="p_1">Tag of the product<br />
                                    Take a picture
                                </p>

                                <p className="p_1">Your Order/s<br />
                                Select an order
                                </p>

                                <p className="p_1">Please describe the issue . We’ll get back to you within 24 hours</p>
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            18. I WASN’T AVAILABLE AT THE TIME OF THE DELIVERY, BUT I WANT MY ORDER. WHAT SHOULD I DO?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Contact our <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive, to resolve this. We’ll get back to you within 24 hours.
                            </span>
                        </div>

                        <h3 className="pg ftr">
                            19. I TRIED TO MAKE A TRANSACTION,BUT IT FAILED. WHAT DO I DO?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                If the amount has been deducted from your bank or card, don’t worry; it will be refunded to the same account within 7-10 business days.

                                <p className="p_1"> Meanwhile, please wait a while and try again, preferably using a different payment method.</p>
                                These are the payment methods we accept:

                                • Debit Card<br />
                                • Credit Card<br />
                                • Net banking<br />
                                {/* • Leading e-wallets<br /> */}
                                For any further inquiries, please feel free to contact our <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive. We’ll get back to you within 24 hours.
                            </span>
                        </div>
                        {/* <h3 className="pg ftr">
                        20. WHEN WILL I RECEIVE CASHBACK OF MY ORDER?
                        </h3>     */}
                        {/* <p className="pg"><span style={{"font-weight": "300;"}}>
                        Prepaid order cashback will get credited to your SC wallet once the order gets shipped<br />
                        Also for products that are already discounted, loyalty amount will not be applicable to the design of the day and factory outlet products.
                        </span>
                        </p> */}
                        {/* <h3 className="pg ftr">
                        21. I HAVE LOYALTY MONEY IN MY SC WALLET. CAN I TRANSFER IT TO MY BANK ACCOUNT?
                        </h3>     */}
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                No. The Loyalty Money is associated with your StyleCabbie account only, and cannot be en-cashed or transferred to other accounts.
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            22. CAN I PAY USING AN INTERNATIONAL CARD?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                We currently do not accept payment via international cards.
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            23.I HAVE SELF-SHIPPED. HOW DO I GET THE REFUND?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                If you have self-shipped the product already, please email us the screenshot of the courier receipt along with the order id number.

                                <p className="p_1">Our <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive will work on your query. We will get back to you in the next 24 hours.</p>

                                <p className="p_1">Image of the product<br />
                                    Take a picture
                                </p>

                                <p className="p_1">Tag of the product<br />
                                Take a picture</p>

                                <p className="p_1">Your Order/s<br />
                                Select an order</p>

                                Please describe the issue . We’ll get back to you within 24 hours
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            24. WILL STYLECABBIE.COM EMPLOYEE ASK FOR MY CONFIDENTIAL INFORMATION?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Stylecabbie.com employees will never ask for your credentials like StyleCabbie password, OTP, Credit/Debit card expiry and CVV or any other confidential information except for your name, address, e-mail id and mobile number.
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            25. I’M HAVING A TECHNICAL ISSUE WITH YOUR WEBSITE. CAN YOU HELP ME RESOLVE THIS?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                The StyleCabbie website has been tested to work on multiple devices and browsers. However, you may find that switching to a different browser, deleting cookies and/or cache may resolve the technical issue you are experiencing.<br />
                                If you still continue to experience the error, please contact the <a className="customer-care" href="mailto:support@stylecabbie.com">support@stylecabbie.com</a> executive. You may need to provide information about your device and browser for our team to troubleshoot, so please ensure this information is available.
                            </span>
                        </div>
                        <h3 className="pg ftr">
                            26. DOES STYLECABBIE OFFER PRICE ADJUSTMENTS ON PREVIOUSLY-PURCHASED MERCHANDISE OR PRICE MATCHING?
                        </h3>    
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                StyleCabbie does not offer price adjustments on previously purchased merchandise or price matching with other retailers.
                            </span>
                        </div>
                    </div>
                </main>

                <Footer />

            </React.Fragment>
        )
    }
}
export default  FAQ 
